<script lang="ts" setup>
import {
  CdrLink, CdrList, CdrText, CdrContainer,
} from '@rei/cedar';
</script>

<template>
  <cdr-container class="not-found-page">
    <div
      class="not-found-page__content"
      data-ui="not-found"
    >
      <cdr-text
        tag="h1"
        class="not-found-page__title"
      >
        We’re sorry...
      </cdr-text>
      <cdr-text
        tag="p"
        class="not-found-page__intro-text text-body"
      >
        The page you're looking for is not available for one of the following reasons:
      </cdr-text>
      <cdr-list
        modifier="compact unordered"
        class="not-found-page__description-list text-body"
      >
        <li>The link to this page may be incorrect or out-of-date.</li>
        <li>You may have bookmarked a page that has been moved.</li>
      </cdr-list>
      <cdr-text
        tag="p"
        class="text-body"
      >
        Please return to the
        <cdr-link href="/purchase-history">
          purchase history page
        </cdr-link> to look for another
        order or if you would like, you may continue shopping from our homepage or use our search
        feature. You can also
        <cdr-link href="/help">
          contact us for help.
        </cdr-link>
      </cdr-text>
    </div>
  </cdr-container>
</template>

<style lang="scss">
.not-found-page {
  &__content {
    margin: 0 auto $cdr-space-four-x;

    @include cdr-sm-mq-up {
      max-width: 633px;
    }
    @include cdr-md-mq-up {
      max-width: 746px;
    }
  }

  &__intro-text,
  &__description-list {
    margin-bottom: $cdr-space-two-x;
  }

  &__title {
    @include cdr-text-heading-serif-600;
    margin-top: $cdr-space-four-x;
    margin-bottom: $cdr-space-one-x;
  }
}
</style>
